import React from 'react';
import '../../../styles/maintenance/MaintenanceRequests.css';
import tableData from './todaysFakeData';

const TodayRequestsShort = ({
  setReadDetails,
  setDetailsID,
  setFormOpen,
  setWorkOrderOpen
}) => {
  const handleDataClick = (id) => {
    setFormOpen(true);
    setReadDetails(true);
    setDetailsID(id);
    setWorkOrderOpen(false);
  };
  return (
    <table className='table-maintenance-requests short-tables'>
      <thead className='thead'>
        <tr>
          <th scope='col'></th>
        </tr>
      </thead>
      {tableData.length > 0 ? (
        <tbody>
          {tableData.map((data, id) => {
            return (
              <tr key={id} onClick={() => handleDataClick(id)}>
                <td>{data.title}</td>
              </tr>
            );
          })}
        </tbody>
      ) : (
        <tbody>
          <p className='loading'>Loading Data...</p>
        </tbody>
      )}
    </table>
  );
};

export default TodayRequestsShort;
